module.exports = __webpack_public_path__ + "img/logo.20f97695.png";